import { render, staticRenderFns } from "./alledit.vue?vue&type=template&id=37372da4&scoped=true"
import script from "./alledit.vue?vue&type=script&lang=ts"
export * from "./alledit.vue?vue&type=script&lang=ts"
import style0 from "./alledit.vue?vue&type=style&index=0&id=37372da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37372da4",
  null
  
)

export default component.exports